<template>
  <v-menu
    v-model="menu"
    :close-on-content-click="false"
    :nudge-right="40"
    lazy
    transition="scale-transition"
    full-width
    min-width="290px"
  >
    <template v-slot:activator="{ on }">
      <v-text-field
        :error-messages="errorMessages"
        :required="required"
        @focus="focused"
        @input="updateSelf"
        :value="content"
        :label="label"
        :prepend-inner-icon="icon ? 'date_range' : ''"
        :disabled="disabled"
        :append-icon="(clearable && content != undefined && content.trim() != '') ? 'close' : ' '"
        @click:append="handleClear"
        v-on="on"
        :rules="rules"
        :flat="flat"
        :solo-inverted="soloInverted"
        :dense="dense"
      ></v-text-field>
    </template>
    <v-date-picker no-title :value="content" @input="updateSelf"></v-date-picker>
  </v-menu>
</template>

<script>
export default {
  name: "DateInputIcon",
  model: {
    prop: "content",
    event: "input"
  },
  props: {
    content: String,
    label: String,
    errorMessages: String,
    required: Boolean,
    disabled: false,
    clearable: false,
    rules: Array,
    flat: {
      type: Boolean,
      default: false
    },
    soloInverted: {
      type: Boolean,
      default: false
    },
    icon: {
      type: Boolean,
      default: true
    },
    dense: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      menu: false
    };
  },
  methods: {
    updateSelf(content) {
      this.menu = false;
      this.$emit("input", content);
      this.$emit("submitted");
    },
    focused() {
      this.$emit("focused");
    },
    handleClear() {
      if (this.clearable) {
        this.$emit("input", "");
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>
